import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../utils/theme';
import transformTag from '../../utils/transformTag';
import InfoBar from '../infoBar';
import { motion } from 'framer-motion';
import Cards from './normalCards';
import MapListings from './mapListings';

const Wrapper = styled.div<{ allsSectionsEmpty: boolean }>`
  display: grid;
  grid-template-columns: ${p => (p.allsSectionsEmpty ? '1fr' : '45fr 55fr')};
  width: 100%;
  height: 1334px;
`;

const Card = styled(motion.div)`
  bottom: 0;
  z-index: 9;
  border-radius: 4px;
  background-color: ${colors.white};
`;

const CardsContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
`;

const Content = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const TagsContainerWhite = styled.div`
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
`;

const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  height: 80px;
  width: 1280px;
  background-color: ${colors.lightGreen};
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
`;

const Tag = styled.div<{ selected: boolean }>`
  color: ${colors.white};
  cursor: pointer;
  border: solid 1px ${colors.white};
  padding-top: 4px;
  padding-bottom: 4px;
  font-weight: bold;
  text-transform: capitalize;

  ${p =>
    p.selected &&
    css`
      background-color: white;
      color: ${colors.lightGreen};
      border-color: ${colors.lightGreen};
    `}
`;

const NormalListing = ({ tags, items, setSelectedTags, selectedTags, viewport, geojson, allsSectionsEmpty }) => {
  const changeSelectedTags = (id: string) => {
    let selected: string[] = [];
    if (selectedTags.includes(id)) {
      selected = [...selectedTags.filter(t => t !== id)];
    } else {
      selected = [...selectedTags, id];
    }
    sessionStorage.setItem(`selectedTags`, JSON.stringify(selected));
    setSelectedTags(selected);
  };
  return (
    <>
      <div className="mt-28">
        <InfoBar
          title={'Everything is Local!'}
          subtitle={
            allsSectionsEmpty
              ? 'Nothing to show yet, back later'
              : 'Select a category to view listings and map locations. Click in the listing or map icon to see more.'
          }
          image={'/listing.png'}
        />
      </div>
      <>
        {!allsSectionsEmpty && (
          <TagsContainerWhite>
            <TagsContainer>
              {tags.map(t => (
                <Tag selected={selectedTags.includes(t)} onClick={() => changeSelectedTags(t)} className="px-2 xl:px-6">
                  {transformTag(t)}
                </Tag>
              ))}
            </TagsContainer>
          </TagsContainerWhite>
        )}

        <Wrapper allsSectionsEmpty={allsSectionsEmpty}>
          {!allsSectionsEmpty && (
            <Card
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              transition={{
                delay: 1.5,
                default: { duration: 0.5 },
              }}>
              <Content>
                <CardsContent>
                  <Cards item={items} />
                </CardsContent>
              </Content>
            </Card>
          )}
          <MapListings geojson={geojson} viewport={viewport} />
        </Wrapper>
      </>
    </>
  );
};

export default NormalListing;
